import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BadgeModule } from '../badge';
import { ButtonComponent } from './components';

@NgModule({
    imports: [
        CommonModule,

        BadgeModule,
    ],
    declarations: [
        ButtonComponent,
    ],
    exports: [
        ButtonComponent,
    ],
})

export class ButtonModule {}
